if (!customElements.get('collection-images')) {
  customElements.define('collection-images', 
    class CollectionImages extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.setSlider();
      }
    
      setSlider() {
        // console.log(this.dataset.desktopColumns);
        // console.log(this.dataset.mobileColumns);
        
        const swiper = new Swiper(`#Slider-${this.dataset.sectionId}`, {
          // Optional parameters
          loop: true,
          spaceBetween: 40,
          slidesPerView: parseInt(this.dataset.mobileColumns),
          grabCursor: true,
          
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
            
          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          
          breakpoints: {
            575: {
              spaceBetween: 20,
              slidesPerView: parseInt(this.dataset.desktopColumns) - 2,
            },
            991: {
              spaceBetween: 20,
              slidesPerView: parseInt(this.dataset.desktopColumns) - 1,
            },
            1100: {
              spaceBetween: 20,
              slidesPerView: parseInt(this.dataset.desktopColumns),
            },
          },
        });
      }
    }
  );
}
